if (!customElements.get('custom-map-embed')) {
    class CustomMapEmbed extends HTMLElement {
        constructor() {
            super();

            this.init();
        }

        init() {
            this.mapFrame = this.querySelector('[data-map-embed-iframe]');
            this.consentMessage = this.querySelector('[data-map-consent-message]');

            this.bindConsentListeners();
            this.initMapEmbed();
        }

        bindConsentListeners() {
            window.addEventListener('CookiebotOnConsentReady', () => {
                this.handleCookiebotConsent();
            });

            window.addEventListener('CookiebotOnAccept', () => {
                this.handleCookiebotConsent();
            });

            window.addEventListener('CookiebotOnDecline', () => {
                this.showConsentMessage();
            });

            window.addEventListener('UC_UI_INITIALIZED', () => {
                this.handleUsercentricsConsent();
            });

            // Usercentrics recommends custom consent window events such as ucConsent.
            // We mirror the existing map.js fallback by listening for the documented examples.
            ['ucConsent', 'ucEvent'].forEach((eventName) => {
                window.addEventListener(eventName, (event) => {
                    this.handleUsercentricsConsentEvent(event);
                });
            });
        }

        initMapEmbed() {
            var cmpProvider = this.detectCmpProvider();

            if (cmpProvider === 'cookiebot') {
                this.handleCookiebotConsent();
                return;
            }

            if (cmpProvider === 'usercentrics') {
                this.handleUsercentricsConsent();
                return;
            }

            this.hideConsentMessage();
            this.activateIframe();
        }

        detectCmpProvider() {
            if (window.Cookiebot || document.querySelector('script[src*="consent.cookiebot.com/uc.js"]')) {
                return 'cookiebot';
            }

            if (window.UC_UI || document.querySelector('script[src*="app.usercentrics.eu"]')) {
                return 'usercentrics';
            }

            return null;
        }

        handleCookiebotConsent() {
            if (!window.Cookiebot) {
                this.showConsentMessage();
                return;
            }

            if (window.Cookiebot.consent && window.Cookiebot.consent.marketing) {
                this.hideConsentMessage();
                this.activateIframe();
                return;
            }

            this.showConsentMessage();
        }

        handleUsercentricsConsent() {
            if (!window.UC_UI || typeof window.UC_UI.getServicesBaseInfo !== 'function') {
                this.showConsentMessage();
                return;
            }

            var mapsService = window.UC_UI.getServicesBaseInfo().find((service) => {
                return service.name === 'Google Maps';
            });

            if (mapsService && mapsService.consent && mapsService.consent.status) {
                this.hideConsentMessage();
                this.activateIframe();
                return;
            }

            this.showConsentMessage();
        }

        handleUsercentricsConsentEvent(event) {
            if (!event.detail || event.detail.event !== 'consent_status') {
                return;
            }

            if (event.detail['Google Maps'] === true) {
                this.hideConsentMessage();
                this.activateIframe();
                return;
            }

            if (event.detail['Google Maps'] === false) {
                this.showConsentMessage();
            }
        }

        activateIframe() {
            if (!this.mapFrame || this.mapFrame.dataset.loaded === 'true') {
                return;
            }

            // Cookiebot documents data-cookieblock-src for blocked iframes, while
            // Usercentrics documents data-src. We keep both and promote one to src once.
            var frameSrc = this.mapFrame.getAttribute('src')
                || this.mapFrame.dataset.src
                || this.mapFrame.getAttribute('data-cookieblock-src');

            if (!frameSrc) {
                return;
            }

            this.mapFrame.src = frameSrc;
            this.mapFrame.dataset.loaded = 'true';
        }

        showConsentMessage() {
            if (this.consentMessage && this.mapFrame && this.mapFrame.dataset.loaded !== 'true') {
                this.consentMessage.hidden = false;
            }
        }

        hideConsentMessage() {
            if (this.consentMessage) {
                this.consentMessage.hidden = true;
            }
        }
    }

    customElements.define('custom-map-embed', CustomMapEmbed);
}
